/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type STORY_MODE = "COMMENTS" | "QA" | "RATINGS_AND_REVIEWS" | "%future added value";
export type AllCommentsTabQueryLocal = {
    readonly storyID: string | null;
    readonly storyURL: string | null;
    readonly storyMode: STORY_MODE | null;
    readonly ratingFilter: number | null;
    readonly commentsOrderBy: COMMENT_SORT;
    readonly refreshStream: boolean | null;
    readonly " $refType": "AllCommentsTabQueryLocal";
};
export type AllCommentsTabQueryLocal$data = AllCommentsTabQueryLocal;
export type AllCommentsTabQueryLocal$key = {
    readonly " $data"?: AllCommentsTabQueryLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabQueryLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllCommentsTabQueryLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyID",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyURL",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyMode",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ratingFilter",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsOrderBy",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refreshStream",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '8aea8c99f4804a4ba1cde1703efe5059';
export default node;
